import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, withModifiers as _withModifiers } from "vue";
const _hoisted_1 = { class: "form-list-select-wrapper" };
const _hoisted_2 = { class: "custom-input-group" };
const _hoisted_3 = { class: "input-wrapper" };
const _hoisted_4 = ["id", "disabled"];
const _hoisted_5 = ["aria-labelledby"];
const _hoisted_6 = {
    key: 0,
    class: "dropdown-divider"
};
const _hoisted_7 = ["onClick"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_FormInput = _resolveComponent("FormInput");
    const _component_FormElementDescription = _resolveComponent("FormElementDescription");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
                _createVNode(_component_FormInput, {
                    id: _ctx.id,
                    modelValue: _ctx.textValue,
                    "onUpdate:modelValue": [
                        _cache[0] || (_cache[0] = ($event) => ((_ctx.textValue) = $event)),
                        _ctx.handleTextInput
                    ],
                    type: "text",
                    placeHolder: _ctx.placeHolder,
                    disabled: _ctx.disabled,
                    filterFunc: null,
                    warningFunc: null,
                    description: undefined,
                    delayBetweenChangesDetected: _ctx.delayBetweenChangesDetected,
                    ariaDescribedBy: _ctx.id + '-dropdown-button'
                }, null, 8, ["id", "modelValue", "placeHolder", "disabled", "delayBetweenChangesDetected", "onUpdate:modelValue", "ariaDescribedBy"])
            ]),
            (_ctx.options && _ctx.options.length > 0)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    class: _normalizeClass(`btn btn-primary dropdown-toggle btn-sm custom-add-button ${_ctx.disabled ? 'disabled' : ''}`),
                    type: "button",
                    id: _ctx.id + '-dropdown-button',
                    "data-bs-toggle": "dropdown",
                    "aria-expanded": "false",
                    disabled: _ctx.disabled
                }, " Add ", 10, _hoisted_4))
                : _createCommentVNode("", true),
            (_ctx.options && _ctx.options.length > 0)
                ? (_openBlock(), _createElementBlock("ul", {
                    key: 1,
                    class: "dropdown-menu dropdown-menu-end form-list-select-dropdown-menu",
                    "aria-labelledby": _ctx.id + '-dropdown-button'
                }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.actualOptions, (option) => {
                        return (_openBlock(), _createElementBlock("li", {
                            key: option.val
                        }, [
                            (option.val === '--separator--')
                                ? (_openBlock(), _createElementBlock("hr", _hoisted_6))
                                : (_openBlock(), _createElementBlock("a", {
                                    key: 1,
                                    class: _normalizeClass(`dropdown-item ${option.disabled ? 'disabled' : ''}`),
                                    onClick: _withModifiers(($event) => (_ctx.handleDropdownItemClick(option)), ["prevent"])
                                }, _toDisplayString(option.description), 11, _hoisted_7))
                        ]));
                    }), 128))
                ], 8, _hoisted_5))
                : _createCommentVNode("", true)
        ]),
        _createVNode(_component_FormElementDescription, {
            description: _ctx.description,
            warning: _ctx.currentWarningMessage,
            validate: false
        }, null, 8, ["description", "warning"])
    ]));
}
